function o(r, n) {
  return function(e) {
    return r(n(e));
  };
}
var t = o;
export {
  t as _
};
//# sourceMappingURL=_overArg.js.map
